import { apiBaseURL, authActionType, toastifyType, Tokens, ycrType } from "../../../constant";
import { setLoading } from "../loadingAction";
import apiConfig from '../../../config/apiConfig';
import { addTost } from "../toastAction";
import { environment } from "../../../config/environment";
import { metaDataAction } from "../metaDataAction";

export const ycrAction = (payload, getMeta = true) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await apiConfig.post(apiBaseURL.INTEREST_RATES_DATA_TYPES, payload);
    dispatch({ type: ycrType.FETCH_INTEREST_RATES_DATA_TYPES, payload: response.data.data });
    getMeta && dispatch(metaDataAction({ pageSize: payload?.perPage, totalPages: response.data.data.totalPage, totalItems: response.data.data.totalRecords }))
    dispatch(setLoading(false));
    return response
  } catch (error) {
    dispatch(setLoading(false));
    dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
  }
};


// export const ycrActionWithCountry = (payload) => async (dispatch) => {

//   try {
//     dispatch(setLoading(true));
//     const response = await apiConfig.post(apiBaseURL.INTEREST_RATES_DATA_TYPES, payload);
//     dispatch({ type: ycrType.FETCH_INTEREST_RATES_DATA_TYPES, payload: response.data.data });
//     dispatch(setLoading(false));
//   } catch (error) {
//     dispatch(setLoading(false));
//     dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
//   }
// };
